<template>
  <md-card>
  <div class="topNav">
   <div v-if="true">
     <h1>{{ device.title }}</h1>
   </div>

    <md-menu md-direction="bottom-start" v-else>
      <md-button md-menu-trigger> -- </md-button>

      <md-menu-content >
        <md-menu-item v-for="(met, i) in device.metrics" @click="$emit('changeDevice', i)" md-close-on-select>
          <md-button  class="md-primary">{{ met.name }}</md-button>
        </md-menu-item>

      </md-menu-content>
    </md-menu>

  </div>
  <div class="subNav">
    <h2>{{ device.subtitle}}</h2>
  </div>

</md-card>
</template>

<style>
#airsset_widget #header-img {
  height: 70px;
  margin-right: 10px;
}

#airsset_widget .topNav{
  width: 100%;
  background-color: #48a0d3; /* #5bc0de; */
  padding: 8px;
  color: white;
  height: 34px;
  font-weight: bold;
  text-align:center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

#airsset_widget .subNav{
  width: 100%;
  background-color: #EEE;
  text-align: center;
}
#airsset_widget h1 {
  font-size: 1rem;
  font-weight: bold;
}
#airsset_widget h2 {
  font-size: 0.6rem;
  padding: 8px 0;
  font-weight: bold;
  margin-bottom: 0;
}

</style>

<script>
  export default {
    name: "Navbar",
    props: ['device']
  }
</script>
